import React, { useState, useEffect } from 'react';
import DataTableDocumentActionModal from 'components/DataTableDocumentActionModal';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import FormField from 'layouts/applications/wizard/components/FormField';
import Swal from 'sweetalert2';
import axios from 'axios';
import ClientSelector from 'components/ClientSelector';

const ProviderModal = ({ show, handleClose, getData, document, onClose }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        nombre: '',
        direccion: '',
        ciudad: '',
        estado: '',
        zipcode: '',
        id_cliente: 0
    });

    useEffect(() => {
        if(document) {
            setFormData({
                nombre: document.nombre,
                direccion: document.direccion,
                ciudad: document.ciudad,
                estado: document.estado,
                zipcode: document.zipcode,
                id_cliente: document.id_cliente || 0
            });
        } else {
            setFormData({
                nombre: '',
                direccion: '',
                ciudad: '',
                estado: '',
                zipcode: '',
                id_cliente: 0
            });
        }
    }, [document]);

    const handleSubmit = async () => {
        try {
            setIsLoading(true);
            const url = document 
                ? `${process.env.REACT_APP_SERVER_URL}/api/maintenance/provider/${document.id_proveedor}/`
                : `${process.env.REACT_APP_SERVER_URL}/api/maintenance/providers/`;
            
            const response = document
                ? await axios.put(url, formData)
                : await axios.post(url, formData);

            getData();
            Swal.fire({
                icon: 'success',
                title: document ? 'Proveedor actualizado' : 'Proveedor creado',
                text: `El proveedor ha sido ${document ? 'actualizado' : 'creado'} exitosamente`,
            });
        } catch(error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: `Ocurrió un error al ${document ? 'actualizar' : 'crear'} el proveedor`,
            });
        } finally {
            handleClose();
            onClose && onClose();
            setIsLoading(false);
        }
    };

    const handleChange = (field) => (e) => {
        setFormData({ ...formData, [field]: e?.target?.value || e });
    };

    return (
        <DataTableDocumentActionModal
            show={show}
            handleClose={() => {
                handleClose();
                onClose && onClose();
            }}
            title={document ? "Editar Proveedor" : "Nuevo Proveedor"}
            handleSubmit={handleSubmit}
            isSubmitting={isLoading}
            submitText={document ? "Actualizar" : "Crear"}
        >
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <ClientSelector
                        selectedClient={formData.id_cliente}
                        setSelectedClient={({ value }) => {
                            setFormData({ ...formData, id_cliente: value });
                        }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormField
                        type="text"
                        label="Nombre Proveedor"
                        value={formData.nombre}
                        onChange={handleChange('nombre')}
                        placeholder="Ingrese el nombre del proveedor"
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormField
                        type="text"
                        label="Dirección"
                        value={formData.direccion}
                        onChange={handleChange('direccion')}
                        placeholder="Ingrese la dirección"
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormField
                        type="text"
                        label="Ciudad"
                        value={formData.ciudad}
                        onChange={handleChange('ciudad')}
                        placeholder="Ingrese la ciudad"
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormField
                        type="text"
                        label="Estado"
                        value={formData.estado}
                        onChange={handleChange('estado')}
                        placeholder="Ingrese el estado"
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormField
                        type="text"
                        label="Código Postal"
                        value={formData.zipcode}
                        onChange={handleChange('zipcode')}
                        placeholder="Ingrese el código postal"
                    />
                </Grid>
            </Grid>
        </DataTableDocumentActionModal>
    );
};

ProviderModal.propTypes = {
    show: PropTypes.bool,
    getData: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
    document: PropTypes.shape({
        id_proveedor: PropTypes.number,
        nombre: PropTypes.string,
        direccion: PropTypes.string,
        ciudad: PropTypes.string,
        estado: PropTypes.string,
        zipcode: PropTypes.string,
        id_cliente: PropTypes.number
    }),
    onClose: PropTypes.func,
};

export default ProviderModal;